import { useState } from "react";
import { formatCost, turnCost } from "../../pricing";

export type TurnUsage = {
  lastInputTokens: number;
  totalOutputTokens: number;
  totalBilledTokens: number;
};

type Props = {
  usage: TurnUsage | undefined;
  modelId?: string | null;
  effort?: string | null;
};

export function MessageStats({ usage, modelId, effort }: Props) {
  const [open, setOpen] = useState(false);
  if (!usage && !modelId) return null;
  const cost = usage ? turnCost(modelId, usage.lastInputTokens, usage.totalOutputTokens) : null;
  const summaryParts: string[] = [];
  if (modelId) summaryParts.push(shortModel(modelId));
  if (effort && effort !== "off") summaryParts.push(effort);
  if (usage) summaryParts.push(`${usage.totalBilledTokens.toLocaleString()} tok`);
  const summary = summaryParts.join(" · ");
  return (
    <>
      <button
        type="button"
        className="message-stats-toggle"
        onClick={() => setOpen((o) => !o)}
        title="Toggle token usage"
      >
        {open ? "hide stats" : summary}
      </button>
      {open && (
        <div className="message-stats">
          {modelId && <span title="Model used for this turn">model {modelId}</span>}
          {effort && <span title="Reasoning effort for this turn">effort {effort}</span>}
          {usage && (
            <>
              <span title="Input tokens of the final invocation = current context size">
                ctx {usage.lastInputTokens.toLocaleString()}
              </span>
              <span title="Output tokens generated this turn">
                out {usage.totalOutputTokens.toLocaleString()}
              </span>
              <span title="Total billed tokens this turn (sums multi-step tool-use)">
                billed {usage.totalBilledTokens.toLocaleString()}
              </span>
              <span title="Estimated USD cost for this turn (on-demand us-east-1 list price)">
                cost {formatCost(cost)}
              </span>
            </>
          )}
        </div>
      )}
    </>
  );
}

function shortModel(modelId: string): string {
  // Strip the cross-region prefix and `anthropic.claude-` for compact display.
  return modelId
    .replace(/^(us|global)\./, "")
    .replace(/^anthropic\.claude-/, "")
    .replace(/-v\d+(?::\d+)?$/, "");
}
